/**
 * UNA PALABRA POR CONCEPTO
 * ========================
 *
 * Cómo se llama cada estado y cada opción en pantalla, en un solo lugar. El badge, la fila,
 * el filtro y el gráfico dicen lo mismo porque leen de acá. Si un concepto tuviera dos
 * nombres en dos pantallas, la persona pensaría que son dos cosas.
 */

export const NOMBRE_ESTADO_CUOTA = {
  PAGADA: 'Pagada',
  VENCIDA: 'Vencida',
  POR_VENCER: 'Por vencer',
  PENDIENTE: 'Pendiente',
} as const;

export const NOMBRE_ESTADO_CUENTA = {
  PAGADA: 'Pagada',
  AL_DIA: 'Al día',
  ATRASADA: 'Con atraso',
  ANULADA: 'Anulada',
  SIN_DEUDA: 'Sin deuda',
} as const;

export const NOMBRE_ESTADO_STOCK = {
  SIN_CONTROL: 'Sin control de stock',
  NEGATIVO: 'A reponer',
  AGOTADO: 'Agotado',
  BAJO: 'Stock bajo',
  OK: 'Con stock',
} as const;

export const NOMBRE_METODO = {
  SIN_INTERES: 'Sin interés',
  INTERES_SIMPLE: 'Interés simple',
  FRANCES: 'Sistema francés',
  MANUAL: 'Montos a mano',
} as const;

export const DESCRIPCION_METODO = {
  SIN_INTERES: 'El saldo se reparte en cuotas iguales.',
  INTERES_SIMPLE: 'Interés fijo por cuota sobre el saldo inicial. El más fácil de explicar.',
  FRANCES: 'Cuota fija con interés sobre el saldo que queda, como un préstamo.',
  MANUAL: 'Escribís el monto de cada cuota.',
} as const;

export const NOMBRE_FRECUENCIA = {
  MENSUAL: 'Mensual',
  QUINCENAL: 'Quincenal',
  SEMANAL: 'Semanal',
} as const;

export const NOMBRE_TIPO_MORA = {
  NINGUNA: 'Sin mora',
  PORCENTAJE_DIARIO: '% diario',
  PORCENTAJE_MENSUAL: '% mensual',
  MONTO_FIJO_DIARIO: 'Monto fijo por día',
  MONTO_FIJO_UNICO: 'Monto fijo único',
} as const;

export const NOMBRE_MOVIMIENTO_STOCK = {
  ENTRADA: 'Entrada',
  SALIDA_VENTA: 'Venta',
  AJUSTE_POSITIVO: 'Ajuste (+)',
  AJUSTE_NEGATIVO: 'Ajuste (−)',
  DEVOLUCION: 'Devolución',
} as const;

export const NOMBRE_TABLA = {
  entidad: 'Entidad',
  plan: 'Plan',
  modulo_entidad: 'Módulo',
  usuario: 'Usuario',
  membresia: 'Miembro',
  rol: 'Rol',
  archivo: 'Archivo',
  cliente: 'Cliente',
  categoria: 'Categoría',
  producto: 'Producto',
  movimiento_stock: 'Movimiento de stock',
  medio_pago: 'Medio de pago',
  plan_financiacion: 'Plan de financiación',
  venta: 'Venta',
  venta_linea: 'Línea de venta',
  cuota: 'Cuota',
  pago: 'Pago',
  aplicacion_pago: 'Imputación de pago',
  recibo: 'Recibo',
  factura: 'Factura',
} as const;

/** Código visible de un recibo: R-000123. */
export function codigoRecibo(prefijo: string, numero: number): string {
  return `${prefijo}-${String(numero).padStart(6, '0')}`;
}

/** Puntos básicos a texto: 350 → "3,5 %". */
export function textoPorcentaje(bp: number): string {
  const valor = bp / 100;
  return `${valor.toLocaleString('es-PY', { maximumFractionDigits: 2 })} %`;
}
